import { Box, Typography } from '@mui/material';

interface Props {
    dialogData: {
        isCorrect: boolean;
        id?: number;
        recordNumber?: string;
    };
}

export const MsgCreation = ({ dialogData }: Props) => {
    return (
        <Box
            mt={2}
            mb={20}
            padding=".4rem 1rem"
            margin="0 auto"
            minHeight="80vh"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Typography fontSize={20}>
                {dialogData?.isCorrect && Boolean(dialogData.id) ? (
                    <>
                        La información suministrada se registró exitosamente con
                        el número de radicado <b>{dialogData?.recordNumber}</b>.
                    </>
                ) : (
                    <>
                        En este momento tenemos inconvenientes, por favor
                        intentalo mas tarde.
                    </>
                )}
            </Typography>
        </Box>
    );
};
